/**
 * Ads
 * Contains the logic necessary for initiating and displaying DFP Ads on the site
 * version 1.1.2
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('admiral',[
    'jquery',
    'logging',
    'analytics',
    'storage'
], function ($, logging, analytics, storage) {
    'use strict';

    var _ModuleName = 'Admiral Ad-Free';

    var _config = {
        enabled: true,
        storage: {
            subCache: "admiral-user-subscribed",
            pageViewCount: "dfp-page-view-count"
        },
        cache: {
            enabled: true,
            updated: false
        }
    };

    var init = function () {
        window.admiral('targeting', 'pause', 500);

        var pageCount = storage.getSessionStorage(_config.storage.pageViewCount) || 0;

        if (pageCount == 0) {
            window.admiral('targeting', 'set', 'pageViewCount', 'firstPageView');
        }

        window.admiral('targeting', 'ready');

        // Sets a timeout to run if Engage isn't displayed.
        var timeout = setTimeout(function () {
            var dimension12Value = 'No Pop-up';
            analytics.SetDimension(12, dimension12Value);
        }, 3000);

        // Checks to see if Engage rendered.
        window.admiral('after', 'engage.loaded', function (obj) {
            // Clears timeout if Engage does render
            clearTimeout(timeout);

            var dimension12Value = '';

            if (obj.rendered) {
                dimension12Value = 'Had Pop-up';
            } else {
                dimension12Value = 'No Pop-up';
            }

            analytics.SetDimension(12, dimension12Value);
        });

        if (_config.enabled) {
            ;
            window.admiral =
                window.admiral ||
                function () {
                    (admiral.q = admiral.q || []).push(arguments);
                };

            _initAnalytics();
        } else {
            ;
        }
    };

    var checkUserSubscribed = function (isSubscribed, isNotSubscribed, finalFunc, checkOnce) {
        if (typeof checkOnce === undefined) { checkOnce = false; }

        var _respondedWithCache = false;
        if (_config.enabled) {
            ;

            // check local cache
            if (_config.cache.enabled) {
                var cache = storage.getLocalStorage(_config.storage.subCache);
                if (cache) {
                    ;
                    if (cache == "true") {
                        ;
                        if (typeof isSubscribed === 'function') {
                            isSubscribed();
                        }
                    } else if (cache == "false") {
                        ;
                        if (typeof isNotSubscribed === 'function') {
                            isNotSubscribed();
                        }
                    }

                    ;
                    if (typeof finalFunc === 'function') {
                        finalFunc();
                    }

                    _respondedWithCache = true;
                }
            }

            if (_respondedWithCache) {
                // if we've responded with our cached value, we should still attempt one cache update against Admiral in case user has subscribed
                if (!_config.cache.updated) {
                    ;
                    // cache has not been updated, so let's continue to update it
                } else {
                    ;
                    // cache updated not needed, so let's bail out
                    return;
                }
            }


            var responseReceived = false;
            var start = new Date();
            window.admiral('after', 'measure.detected', function (result) {

                // If we only want a single event and response was already received, we're done here
                if (checkOnce && responseReceived) { return; }

                responseReceived = true;

                ;

                var end = new Date();
                var elapsed = end.getTime() - start.getTime();
                logging.log("Admiral subscription check response received after " + elapsed + "ms", _ModuleName);


                // if we haven't alredy responded from the cache, handle that
                if (!_respondedWithCache) {
                    if (result && result.subscribed) {
                        ;

                        if (typeof isSubscribed === 'function') {
                            isSubscribed();
                        }
                    } else {
                        ;
                        if (typeof isNotSubscribed === 'function') {
                            isNotSubscribed();
                        }
                    }

                    ;
                    if (typeof finalFunc === 'function') {
                        finalFunc();
                    }
                }

                // store in cache
                if (_config.cache.enabled) {
                    ;
                    storage.setLocalStorage(_config.storage.subCache, (result && result.subscribed ? "true" : "false"));
                    _config.cache.updated = true;
                }
            });
        } else {
            // Admiral Ad-Free is disabled, so treat as "not subscribed"

            if (typeof isNotSubscribed === 'function') {
                isNotSubscribed();
            }

            if (typeof finalFunc === 'function') {
                finalFunc();
            }
        }
    };

    var showUserLogin = function () {
        // Verify enabled
        if (!_config.enabled) return;

        ;
        window.admiral('show', 'transact.login', { offerID: '5e45c42d5c443b73b53cc7a5,5e45c46f0cb01b0d8a4a3a1a' }, function () {
            ;
        });
    };

    var _initAnalytics = function () {
        // Verify enabled
        if (!_config.enabled) return;

        window.admiral('after', 'measure.detected', function (user) {
            var eventLabel = '';
            if (user.adblocking) {
                eventLabel = 'blocked';
            }
            if (user.whitelisted) {
                eventLabel = 'whitelisted';
            }
            if (user.subscribed) {
                eventLabel = 'subscribed';
            }
            // Only fire GA event if eventLabel is defined so we're not firing events for regular users.
            if (eventLabel) {
                analytics.FireEvent('Admiral', 'pageview', eventLabel, true);
            }
        });
    };

    return {
        init: init,
        checkUserSubscribed: checkUserSubscribed,
        showUserLogin: showUserLogin,
        isEnabled: function () { return _config.enabled; }
    };
});

